import { LENS_MODELS } from "@/lib/lenses";

export const EYE_KEYS = ["k1", "k1_axis", "k2", "k2_axis", "al", "acd", "lt", "wtw"];

export const isEyeFilled = (e) =>
  EYE_KEYS.every((k) => e[k] !== "" && e[k] !== null && !Number.isNaN(parseFloat(e[k])));

const numOrNull = (v) => {
  if (v === "" || v === null || v === undefined) return null;
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : null;
};

const eyePayload = (eye) =>
  isEyeFilled(eye) ? Object.fromEntries(Object.entries(eye).map(([k, v]) => [k, parseFloat(v)])) : null;

export function buildCalculationPayload(patient, od, os) {
  const aConst = parseFloat(patient.a_constant) || 119.84;
  return {
    patient_name: patient.patient_name,
    patient_id: patient.patient_id,
    age: patient.age ? parseInt(patient.age, 10) : null,
    prior_surgery: patient.prior_surgery,
    target_refraction: parseFloat(patient.target_refraction) || 0,
    a_constant: aConst,
    a_constant_other: parseFloat(patient.a_constant_other) || aConst,
    hoffer_pacd: numOrNull(patient.hoffer_pacd),
    c_constant: Math.min(1, Math.max(0, parseFloat(patient.c_constant))) || 0.5,
    lens_id: patient.lens_id || "custom",
    lens_name: LENS_MODELS.find((l) => l.id === patient.lens_id)?.name || "Custom / manual A-const",
    sia: parseFloat(patient.sia) || 0.2,
    sia_axis: parseFloat(patient.sia_axis) || 180,
    od: eyePayload(od),
    os: eyePayload(os),
  };
}

export function mapExtraction(data, emptyEye) {
  const ex = data.extracted || {};
  const pick = (eye) => {
    if (!eye) return null;
    const out = { ...emptyEye };
    for (const k of Object.keys(emptyEye)) if (eye[k] !== null && eye[k] !== undefined) out[k] = eye[k];
    return out;
  };
  const od = pick(ex.od);
  const os = pick(ex.os);
  const eyes = [od && "OD", os && "OS"].filter(Boolean);
  return {
    od,
    os,
    meta: { patient_name: ex.patient_name, patient_id: ex.patient_id, age: ex.age },
    info: {
      device: ex.device,
      pages: data.pages,
      warnings: ex.warnings || [],
      confidence: { od: ex.od?.confidence, os: ex.os?.confidence },
      eyes,
    },
  };
}
